function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgBattery20(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 496 496",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#BCBCBC"
    },
    d: "M88,161.6c-12.8,0-24,10.4-24,23.2v125.6c0,12.8,11.2,23.2,24,23.2s24-10.4,24-23.2V184.8 C112,172,100.8,161.6,88,161.6z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#BCBCBC"
    },
    d: "M168,161.6c-12.8,0-24,10.4-24,23.2v125.6c0,12.8,11.2,23.2,24,23.2s24-10.4,24-23.2V184.8 C192,172,180.8,161.6,168,161.6z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#BCBCBC"
    },
    d: "M240,161.6c-12.8,0-24,10.4-24,23.2v125.6c0,12.8,11.2,23.2,24,23.2c12.8,0,24-10.4,24-23.2V184.8 C264,172,252.8,161.6,240,161.6z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#BCBCBC"
    },
    d: "M312,161.6c-12.8,0-24,10.4-24,23.2v125.6c0,12.8,11.2,23.2,24,23.2s24-10.4,24-23.2V184.8 C336,172,324.8,161.6,312,161.6z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#BCBCBC"
    },
    d: "M392,161.6c-12.8,0-24,10.4-24,23.2v125.6c0,12.8,11.2,23.2,24,23.2s24-10.4,24-23.2V184.8 C416,172,404.8,161.6,392,161.6z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D81D7B"
    },
    d: "M80,334.4c-12.8,0-24-10.4-24-23.2V184.8c0-12.8,11.2-23.2,24-23.2s24,10.4,24,23.2v125.6 C104,324,92.8,334.4,80,334.4z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#C40E72"
    },
    d: "M56,184.8c0-12.8,11.2-23.2,24-23.2s24,10.4,24,23.2V312"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#B9BBB9"
    },
    d: "M160,334.4c-12.8,0-24-10.4-24-23.2V184.8c0-12.8,11.2-23.2,24-23.2s24,10.4,24,23.2v125.6 C184,324,172.8,334.4,160,334.4z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#C2D3D2"
    },
    d: "M136,184.8c0-12.8,11.2-23.2,24-23.2s24,10.4,24,23.2V312"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#B9BBB9"
    },
    d: "M232,334.4c-12.8,0-24-10.4-24-23.2V184.8c0-12.8,11.2-23.2,24-23.2s24,10.4,24,23.2v125.6 C256,324,244.8,334.4,232,334.4z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#B9BBB9"
    },
    d: "M304,334.4c-12.8,0-24-10.4-24-23.2V184.8c0-12.8,11.2-23.2,24-23.2s24,10.4,24,23.2v125.6 C328,324,316.8,334.4,304,334.4z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#B9BBB9"
    },
    d: "M384,334.4c-12.8,0-24-10.4-24-23.2V184.8c0-12.8,11.2-23.2,24-23.2s24,10.4,24,23.2v125.6 C408,324,396.8,334.4,384,334.4z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#C2D3D2"
    },
    d: "M208,184.8c0-12.8,11.2-23.2,24-23.2s24,10.4,24,23.2V312"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#C2D3D2"
    },
    d: "M280,184.8c0-12.8,11.2-23.2,24-23.2s24,10.4,24,23.2V312"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#C2D3D2"
    },
    d: "M360,184.8c0-12.8,11.2-23.2,24-23.2s24,10.4,24,23.2V312"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#BCBCBC"
    },
    d: "M464,174.4L464,174.4c12.8,0,24,10.4,24,24v100c0,12.8-11.2,24-24,24l0,0"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#A9AAA9"
    },
    d: "M464.8,168H464v-16c0-19.2-14.4-32-32.8-32H32.8C15.2,120,0,133.6,0,152v192c0,19.2,15.2,32,32.8,32 h398.4c17.6,0,32.8-13.6,32.8-32v-16h0.8c17.6,0,31.2-12.8,31.2-29.6V197.6C496,180.8,482.4,168,464.8,168z M448,344 c0,10.4-7.2,16-16.8,16H32.8C24,360,16,353.6,16,344V152c0-10.4,8-16,16.8-16h398.4c9.6,0,16.8,6.4,16.8,16L448,344L448,344z  M480,298.4c0,8.8-6.4,13.6-15.2,13.6H464V184h0.8c8.8,0,15.2,4.8,15.2,13.6V298.4z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#B9BBB9"
    },
    d: "M263.2,360H32.8C24,360,16,353.6,16,344V152c0-6.4,3.2-10.4,8-14.4L11.2,128C4,133.6,0,141.6,0,152 v192c0,19.2,15.2,32,32.8,32H280L263.2,360z"
  }));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBattery20);
export default __webpack_public_path__ + "static/media/battery20.9bb5d4b0528c381545e214d6f9550177.svg";
export { ForwardRef as ReactComponent };